import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import imgMediaCardStyle from "assets/jss/material-dashboard-react/components/imgMediaCardStyle.jsx";

function ImgMediaCard(props) {
  const { classes, name, image, desc, tech, demoUrl, liveUrl } = props;
  return (
    <Card className={classes.card}>
      <CardActionArea href={demoUrl} rel="noopener noreferrer" target="_blank" className={classes.cardActionArea}>
        <CardMedia
          component="img"
          className={classes.media}
          height="140"
          image={image}
          title={name}
        />
        <CardContent className={classes.cardContent}>
          <Typography gutterBottom variant="subheading" component="h2">
            {name}
          </Typography>
          <Typography variant="caption" component="span">
            {desc}
          </Typography>
          <Typography variant="caption" component="span">
            Tech: {tech}
          </Typography>
        </CardContent>
      </CardActionArea>
       <CardActions>
        <Button
          href={demoUrl}
          size="small"
          color="primary"
          rel="noopener noreferrer"
          target="_blank"
        >
          Demo
        </Button>
        <Button
          href={liveUrl}
          size="small"
          color="primary"
          rel="noopener noreferrer"
          target="_blank"
        >
          Live
        </Button>
      </CardActions>
    </Card>
  );
}

ImgMediaCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(imgMediaCardStyle)(ImgMediaCard);



// WEBPACK FOOTER //
// ./src/components/Card/ImgMediaCard.jsx